/**
 * Licent
 *
 * @author Robuust
 * @author Rutger Bakker <rutger@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import lgHash from 'lightgallery/plugins/hash';

/**
 * Controller for gallery.
 */
export default class extends Controller {
  static values = {
    id: {
      type: Number,
      default: 1,
    },
    selector: String,
  };

  /**
   * LightGallery instance.
   */
  lg;

  /**
   * Connect gallery.
   */
  connect() {
    this.lg = lightGallery(this.element, {
      galleryId: this.idValue,
      licenseKey: '00000000-00000000-00000000-00000000',
      download: false,
      videoFacade: false,
      youTubeNoCookie: false,
      hashDriver: 'history',
      toolbarOverflow: false,
      selector: this.selectorValue || 'a[href]',
      plugins: [lgVideo, lgHash],
    });
  }

  /**
   * Disconnect gallery.
   */
  disconnect() {
    this.lg.destroy();
  }
}
